//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "menuBlog",
  data() {
    return {
      url: "https://cms-resource.mastergo.com/MGwebsite/post.json",
      length: 2,
      listDatas: [],
    };
  },
  methods: {
    getList() {
      fetch(this.url)
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data)) {
            data.length <= 2
              ? (this.listDatas = data)
              : (this.listDatas = data.slice(1, 3));
          }
        });
    },
    clickHandle(item) {
      location.href = `${location.origin}/blog/${item.id}?${item.title}`;
    },
    getUrlByOrigin(origin) {
      const map = {
        "https://dev.mastergo.com": "https://cms-resource-dev.mastergo.com/MGwebsite/post.json",
        "https://pts.mastergo.com": "https://cms-resource-pts.mastergo.com/MGwebsite/post.json",
        "https://pre.mastergo.com": "https://cms-resource-pre.mastergo.com/MGwebsite/post.json",
        "https://mastergo.com": "https://cms-resource.mastergo.com/MGwebsite/post.json"
      }
      return map[origin] || this.url;
    }
  },
  created() {
    if (globalThis.document) {
      this.url = `${this.getUrlByOrigin(location.origin)}?${parseInt(Date.now()/1000)}`
      this.getList();
    }
  },
};
